export const ContentSpacing = {
    space2: '2px',
    space4: '4px',
    space6: '6px',
    space8: '8px',
    space10: '10px',
    space12: '12px',
    space16: '16px',
    space20: '20px',
    space24: '24px',
    space28: '28px',
    space32: '32px',
    space36: '36px',
    space40: '40px',
    space44: '44px',
    space48: '48px',
    space60: '60px',
    space80: '80px',
    space100: '100px'
};
